import { render, staticRenderFns } from "./JdsButtonGroup.vue?vue&type=template&id=5e2d94ba"
import script from "./JdsButtonGroup.vue?vue&type=script&lang=js"
export * from "./JdsButtonGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports